var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6908 8.16835C17.2064 8.26864 15.0888 9.73582 14.017 10.2172C13.1831 10.5926 12.4639 10.9164 11.8363 10.9164C11.1887 10.9164 11.0913 10.4522 11.2259 9.4292C11.2575 9.19996 11.5612 7.15966 10.0023 7.2485C9.28308 7.29148 8.15977 7.95916 5.14518 10.8591L6.33439 7.88752C7.20553 5.71254 4.8099 3.54616 2.61773 4.9417L1.04453 5.9991C0.832474 6.13378 0.769432 6.41748 0.904114 6.6324L1.39699 7.4061C1.53168 7.62102 1.81537 7.68406 2.03029 7.54652L3.69233 6.4318C4.21959 6.09653 4.85862 6.63813 4.62937 7.20838L1.81537 14.2463C1.62051 14.7305 1.89274 15.5042 2.66645 15.5042C2.90429 15.5042 3.13927 15.4125 3.31407 15.2349C4.52335 14.0256 7.74713 10.9164 9.36618 9.62406C9.30314 10.4408 9.30601 11.3119 9.95649 12.0254C10.3949 12.5068 11.0254 12.7504 11.8335 12.7504C12.8536 12.7504 13.782 12.332 14.7649 11.8907C15.7106 11.4666 17.6019 10.0969 18.7309 10.0052C18.9745 9.98513 19.1665 9.796 19.1665 9.55242V8.63257C19.1722 8.3718 18.9516 8.15115 18.6908 8.16835Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.195d90a798bf5a1fbe4a851403a738bb.svg";
export { ForwardRef as ReactComponent };